<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Manage Campaign Steps</h3>
        </vs-col>
      </vs-row>
      <vs-divider class="m-5" />

      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1" style="margin-left: 72px;">
            <span>Search Campaign: </span>
          </div>

          <CampaignAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchCampaign"
            :searchOn="'campaign'"
            @event-name="handleChildEvent"
          ></CampaignAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetCampaign"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
          <vs-button
            class="ml-5"
            icon="refresh"
            @click="resetAll"
            color="primary"
            >Reset</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <v-select v-model="per_page" :options="size_per_page" />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="7"
          vs-sm="4"
          vs-xs="12"
        >
          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="campaigns"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="campaign_name">Campaign Name</vs-th>
          <vs-th sort-key="postcode">Completed/Total Steps</vs-th>
          <vs-th sort-key="postcode">Estimation Completed Date of Setup</vs-th>
          <vs-th sort-key="postcode"
            >Estimation Completed Date of In Market</vs-th
          >
          <vs-th sort-key="postcode"
            >Estimation Completed Date of Wrap up</vs-th
          >
          <vs-th sort-key="postcode"
            >Estimation Completed Date of Onboarding</vs-th
          >
          <vs-th sort-key="actions">Steps</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].campaign_name">
              {{ data[indextr].campaign_name }}
            </vs-td>
            <vs-td :data="data[indextr].total_steps">
              <span v-if="data[indextr].total_steps != 0">
                {{ data[indextr].total_completed_steps }} /
                {{ data[indextr].total_steps }}
              </span>
            </vs-td>
            <vs-td :data="data[indextr].setup_last_completed">
              {{ data[indextr].setup_last_completed }}
            </vs-td>
            <vs-td :data="data[indextr].market_last_completed">
              {{ data[indextr].market_last_completed }}
            </vs-td>
             <vs-td :data="data[indextr].wrap_up_last_completed">
              {{ data[indextr].wrap_up_last_completed }}
            </vs-td>
             <vs-td :data="data[indextr].onboarding_last_completed">
              {{ data[indextr].onboarding_last_completed }}
            </vs-td>

            <vs-td>
              <vs-button
                v-if="data[indextr].total_steps != 0 && abilities.can('read', 'campaign-steps')"
                class="mr-5"
                @click="updateSteps(data[indextr].id)"
                >Update</vs-button
              >
              <!-- <vs-button
            @click="editSteps"
            >Edit</vs-button
          > -->

              <vs-button
                v-if="data[indextr].total_steps != 0 && abilities.can('read', 'campaign-steps')"
                @click="editSteps(data[indextr].id)"
                >Edit</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import moment from "moment";
import vSelect from "vue-select";
export default {
  data: () => ({
    user_id: null,
    user_role: null,
    abilities: null,

    selected_client_id: null,
    companySearchComponentKey: 0,
    selected: [],
    selected_campaign_status: "All",
    log: [],
    campaigns: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    campaignStatusList: [],
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    CampaignAutocomplete,
    "v-select": vSelect,
    moduleCampaignManagement,
    ClientAutocomplete
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
    selected_campaign_status: function(val) {
      if (val != "All") this.fetchCampaignWithFilter();
    }
  },
  methods: {
    resetAll() {
      this.selected_campaign_status = "All";
      this.resetCampaign();
    },
    resetCampaign() {
      if (this.user_role == "Sales Developer") {
        this.fetchSalesDeveloperAssociatedCampaigns();
      } else {
        this.fetchCampaigns();
      }
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      if (this.user_role == "Sales Developer") {
        this.fetchSalesDeveloperAssociatedCampaigns();
      } else {
        this.fetchCampaigns();
      }
    },
    showAssociatedCampaign() {
      let selected_client = moduleClientManagement.state.clients.datas;
      this.selected_client_id = selected_client[0].id;
      this.fetchCampaignsAsClient(selected_client[0].id);
    },
    searchCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchCampaignWithFilter() {
      let filter = {};
      filter.status = this.selected_campaign_status;
      filter.client_id = this.selected_client_id;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/fetchAllCampaignsWithFilter", filter)
        .then(res => {
          this.campaigns = res.data;
          let self = this;
          self.campaigns = self.campaigns.filter(function(ele) {
            if (ele.campaign_status) {
              self.showStatusName(ele.campaign_status).then(function(data) {
                if (data) {
                  ele.campaign_status = data.data.campaign_status;
                }
              });
            } else {
              ele.campaign_status = null;
            }

            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }
            return ele;
          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getCampaignStatus() {
      this.$store
        .dispatch("campaignsManagement/getCampaignStatus")
        .then(res => {
          this.campaignStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    async showStatusName(statusId) {
      let result = await this.$store
        .dispatch("campaignsManagement/fetchStatus", statusId)
        .then(res => {
          return res;
        })
        .catch(err => {
          console.log(err);
        });

      return result;
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addCampaign() {
      this.$router.push({ path: "/campaigns/choose-campaign-steps" });
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    },
    viewAccount(id) {
      this.$router.replace("/campaign/" + id);
    },
    editAccount(id) {
      this.$router.replace("/campaign/edit/" + id);
    },
    handleChildEvent() {
      this.searchedclients = moduleClientManagement.state.searched_clients;
      console.log(this.searchedclients);

      let self = this;
     self.campaigns = moduleCampaignManagement.state.campaign.datas
        if(self.campaigns){
        console.log(self.campaigns[0])
        this.fetchSingleCampaign(self.campaigns[0].id)
            
        }
    },
    fetchSingleCampaign(campaign_id) {
      this.$store
        .dispatch(
          "campaignsManagement/fetchSingleCampaignsWithSteps",
          campaign_id
        )
        .then(res => {
          let self = this;
          let result = []
          result[0] = res.data
          self.campaigns = result.filter(
            function(ele) {
              if (ele.steps) {
                // total steps
                ele.total_steps = ele.steps.length;
                let completed_count = 0;
                let setup_array = [];
                let market_array = [];
                let wrap_up_array = [];
                let onboarding_array = [];
                ele.steps.forEach(function(step) {
                  if (step.completed_date != null) {
                    ++completed_count;
                    // total completed steps
                    ele.total_completed_steps = completed_count;
                  }
                  step.completed_date = step.end_date
                  if(step.phase == 'Setup'){
                    setup_array.push(moment(step.completed_date).unix());
                    var setup_largest = setup_array[0];
                    for (var i = 0; i < setup_array.length; i++) {
                      if (setup_largest < setup_array[i]) {
                        setup_largest = setup_array[i];
                      }
                    }
                    // last setup completed date
                    ele.setup_last_completed = moment
                      .unix(setup_largest)
                      .format("YYYY-MM-DD");

                  }

                  if(step.phase == 'In Market'){
                    market_array.push(moment(step.completed_date).unix());
                    var market_largest = market_array[0];
                    for (var i = 0; i < market_array.length; i++) {
                      if (market_largest < market_array[i]) {
                        market_largest = market_array[i];
                      }
                    }
                    // last market completed date
                    ele.market_last_completed = moment
                      .unix(market_largest)
                      .format("YYYY-MM-DD");

                  }
                    console.log("Sdfsdfsdf")
                    console.log(step.phase)


                  if(step.phase == 'Wrap up'){
                    wrap_up_array.push(moment(step.completed_date).unix());
                    var wrap_up_largest = wrap_up_array[0];
                    for (var i = 0; i < wrap_up_array.length; i++) {
                      if (wrap_up_largest < wrap_up_array[i]) {
                        wrap_up_largest = wrap_up_array[i];
                      }
                    }
                    // last wrap_up completed date
                    ele.wrap_up_last_completed = moment
                      .unix(wrap_up_largest)
                      .format("YYYY-MM-DD");

                  }

                  if(step.phase == 'Onboarding'){
                    onboarding_array.push(moment(step.completed_date).unix());
                    var onboarding_largest = onboarding_array[0];
                    for (var i = 0; i < onboarding_array.length; i++) {
                      if (onboarding_largest < onboarding_array[i]) {
                        onboarding_largest = onboarding_array[i];
                      }
                    }
                    // last onboarding completed date
                    ele.onboarding_last_completed = moment
                      .unix(onboarding_largest)
                      .format("YYYY-MM-DD");

                  }



                });
              }

              if(ele.total_completed_steps === undefined){
                ele.total_completed_steps = 0
              }
              return ele;
            }
          );
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    confirmDeleteAccount(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Campaign`,
        accept: this.deleteAccount,
        acceptText: "Delete"
      });
    },
    deleteAccount() {
      this.$store
        .dispatch("campaignsManagement/removeCampaign", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchCampaigns();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Campaign Deleted",
        text: "The Campaign was successfully deleted"
      });
    },
    fetchCampaigns() {
      this.$store
        .dispatch(
          "campaignsManagement/fetchAllCampaignsWithSteps",
          this.paginationAttr
        )
        .then(res => {
          let self = this;
          self.campaigns = moduleCampaignManagement.state.campaign.datas.filter(
            function(ele) {
              if (ele.campaign_status) {
                self.showStatusName(ele.campaign_status).then(function(data) {
                  if (data) {
                    ele.campaign_status = data.data.campaign_status;
                  }
                });
              } else {
                ele.campaign_status = null;
              }

              if (ele.client_id) {
                //get promise value
                self.showClientName(ele.client_id).then(function(data) {
                  if (data) {
                    ele.client_id = data.data.company_name;
                  }
                });
              } else {
                ele.client_id = null;
              }

              if (ele.steps) {
                // total steps
                ele.total_steps = ele.steps.length;
                let completed_count = 0;
                let setup_array = [];
                let market_array = [];
                let wrap_up_array = [];
                let onboarding_array = [];
                ele.steps.forEach(function(step) {
                  if (step.completed_date != null) {
                    ++completed_count;
                    // total completed steps
                    ele.total_completed_steps = completed_count;
                  }
                  step.completed_date = step.end_date
                  if(step.phase == 'Setup'){
                    setup_array.push(moment(step.completed_date).unix());
                    var setup_largest = setup_array[0];
                    for (var i = 0; i < setup_array.length; i++) {
                      if (setup_largest < setup_array[i]) {
                        setup_largest = setup_array[i];
                      }
                    }
                    // last setup completed date
                    ele.setup_last_completed = moment
                      .unix(setup_largest)
                      .format("YYYY-MM-DD");

                  }

                  if(step.phase == 'In Market'){
                    market_array.push(moment(step.completed_date).unix());
                    var market_largest = market_array[0];
                    for (var i = 0; i < market_array.length; i++) {
                      if (market_largest < market_array[i]) {
                        market_largest = market_array[i];
                      }
                    }
                    // last market completed date
                    ele.market_last_completed = moment
                      .unix(market_largest)
                      .format("YYYY-MM-DD");

                  }
                    console.log("Sdfsdfsdf")
                    console.log(step.phase)


                  if(step.phase == 'Wrap up'){
                    wrap_up_array.push(moment(step.completed_date).unix());
                    var wrap_up_largest = wrap_up_array[0];
                    for (var i = 0; i < wrap_up_array.length; i++) {
                      if (wrap_up_largest < wrap_up_array[i]) {
                        wrap_up_largest = wrap_up_array[i];
                      }
                    }
                    // last wrap_up completed date
                    ele.wrap_up_last_completed = moment
                      .unix(wrap_up_largest)
                      .format("YYYY-MM-DD");

                  }

                  if(step.phase == 'Onboarding'){
                    onboarding_array.push(moment(step.completed_date).unix());
                    var onboarding_largest = onboarding_array[0];
                    for (var i = 0; i < onboarding_array.length; i++) {
                      if (onboarding_largest < onboarding_array[i]) {
                        onboarding_largest = onboarding_array[i];
                      }
                    }
                    // last onboarding completed date
                    ele.onboarding_last_completed = moment
                      .unix(onboarding_largest)
                      .format("YYYY-MM-DD");

                  }



                });
              }

              if(ele.total_completed_steps === undefined){
                ele.total_completed_steps = 0
              }
              return ele;
            }
          );
          this.total = moduleCampaignManagement.state.campaign.total;
          this.per_page = moduleCampaignManagement.state.campaign.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchSalesDeveloperAssociatedCampaigns() {
      this.paginationAttr.sales_developer_id = this.user_id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchSalesDeveloperAssociatedCampaigns",
          this.paginationAttr
        )
        .then(res => {
          let self = this;
          console.log("sales developer", res);
          self.campaigns = moduleCampaignManagement.state.campaign.datas.filter(
            function(ele) {
              if (ele.campaign_status) {
                self.showStatusName(ele.campaign_status).then(function(data) {
                  if (data) {
                    ele.campaign_status = data.data.campaign_status;
                  }
                });
              } else {
                ele.campaign_status = null;
              }

              if (ele.client_id) {
                //get promise value
                self.showClientName(ele.client_id).then(function(data) {
                  if (data) {
                    ele.client_id = data.data.company_name;
                  }
                });
              } else {
                ele.client_id = null;
              }
              return ele;
            }
          );
          this.total = moduleCampaignManagement.state.campaign.total;
          this.per_page = moduleCampaignManagement.state.campaign.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    async showClientName(clientId) {
      let result = await this.$store
        .dispatch("clientsManagement/fetchClient", clientId)
        .then(res => {
          return res;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });

      return result;
    },
    updateSteps(campaignId) {
      this.$router.push({ path: `/campaigns/steps-dependency/` + campaignId });
    },
    editSteps(campaignId) {
      this.$router.push({
        path: `/campaigns/edit-campaign-step/` + campaignId
      });
    },
    fetchCampaignsAsClient(clientId) {
      let filter = {};
      filter.client_id = clientId;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/fetchAllCampaignsAsClient", filter)
        .then(res => {
          let self = this;
          console.log(res.data);
          self.campaigns = res.data.filter(function(ele) {
            if (ele.campaign_status) {
              self.showStatusName(ele.campaign_status).then(function(data) {
                if (data) {
                  ele.campaign_status = data.data.campaign_status;
                }
              });
            } else {
              ele.campaign_status = null;
            }

            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }
            return ele;
          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
   this.fetchCampaigns();
    this.getCampaignStatus();
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: 0.7rem 0.9rem;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
.filter {
  width: 300px;
}
.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
